export const GOLD_MINE = {
    GOLD_PER_CLICK_PER_LEVEL: level => level,
    GOLD_PER_CLICK_COST: level => ({
        gold: Math.pow(level, 2),
        wood: Math.pow(level, 2)
    }),
    GOLD_MINING_TIME: level => 30 * 1000 * Math.pow(1 - 0.05, level),
    GOLD_MINING_SIZE: level => 10 * level,
    MINING_TIME_UPGRADE_COST: level => ({
        gold: 100 * level,
        wood: 50 * level
    }),
    MINING_SIZE_UPGRADE_COST: level => ({
        gold: 50 * level,
        wood: 100 * level
    })
}

export const WORKERS = {
    GOLD_COST_PER_COUNT: count => (count + 1) * 10,
    WOOD_COST_PER_COUNT: count => 0 // (count + 1) * 10
}

export const FOREST = {
    WOOD_PER_CLICK_PER_LEVEL: level => level,
    WOOD_PER_CLICK_COST: level => ({
        gold: Math.pow(level, 2),
        wood: Math.pow(level, 2)
    }),
    CHOPPING_TIME: level => 30 * 1000 * Math.pow(1 - 0.05, level),
    CHOPPING_SIZE: level => 10 * level,
    CHOPPING_TIME_UPGRADE_COST: level => ({
        gold: 50 * level,
        wood: 100 * level
    }),
    CHOPPING_SIZE_UPGRADE_COST: level => ({
        gold: 100 * level,
        wood: 50 * level
    })
}

export const FARMS = {
    GOLD_COST_PER_COUNT: count => 100 * Math.pow(count + 1, 2),
    WOOD_COST_PER_COUNT: count => 100 * Math.pow(count + 1, 2)
}

export const BLACKSMITH = {
    gold: 100,
    wood: 100
}
